import { Button, Drawer } from "antd";
import React from "react";

interface IWidgetDrawer {
    title: string | React.ReactNode;
    show: boolean;
    onClose: () => void;
    loading?: boolean;
    children?: React.ReactNode;
    width?: string | number;
    style?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
    showTitleActionBtns?: boolean;
    actionBtns?: React.ReactNode;
}

const WidgetDrawer: React.FC<IWidgetDrawer> = ({
    title,
    show,
    onClose,
    loading,
    children,
    width = "90%",
    style,
    bodyStyle,
    showTitleActionBtns = false,
    actionBtns,
}) => {
    return (
        <Drawer
            title={
                <div className="d-flex justify-content-between align-items-center w-100">
                    {title}
                    {showTitleActionBtns && (
                        <div className="d-flex gap-2">{actionBtns}</div>
                    )}
                </div>
            }
            width={width}
            onClose={onClose}
            open={show}
            style={style}
            styles={{
                body: bodyStyle || {
                    ...(!loading ? { backgroundColor: "#F8F9FA" } : {}),
                },
            }}
        >
            {children}
        </Drawer>
    );
};

export default WidgetDrawer;
